module.exports = __webpack_public_path__ + "static/media/calendar.b15cdfa6.svg";